<template>
  <v-container style="max-width: 1800px">
    <modal-delete :dialog = "dialogDelete" @close = "dialogDelete =false; deleteIndex = -1;" @confirm = "deleteProfile" ></modal-delete>
    <modal-devices
      :showDialog="showDialogDevices"
      :devices="devices"
      @close="showDialogDevices = false"
      @addDevice="addDevice"
      section="products"
      :deviceTypes="[
        'inverter',
        'module',
        'stringbox',
        'accessory',
        'cable',
        'connector',
        'rail',
        'transformer',
        'generator',
      ]"
    >
    </modal-devices>

    <modal-devices
      :showDialog="showDialogServices"
      :devices="devices"
      @close="showDialogServices = false"
      @addDevice="addDevice"
      section="services"
      :deviceTypes="['service']"
    >
    </modal-devices>

    <v-dialog v-model="dialogField" width="600px">
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogField = false">
            Fechar
          </v-btn>
        </v-card-actions>
        <v-card-title>
          <span class="headline">Selecionar ítem</span>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Descrição</th>
                  <th class="text-right">Adicionar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(field, indexField) in fields" :key="indexField">
                  <td>{{ field.description }}</td>

                  <td class="text-right">
                    <v-btn class="primary" @click="addField(indexField)"
                      >+</v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card>
      <v-toolbar color="primary" dark>
        Perfis de orçamento
        <v-spacer></v-spacer>
        <v-btn class="secondary" @click="addProfile">+Novo</v-btn>
      </v-toolbar>

      <v-container style="max-width: 90%">
        <div>
          <v-card
            v-for="(quoteProfile, index) in quoteProfiles"
            v-bind:key="index"
          >
            <v-toolbar class="primary" dark>
              <v-btn class="secondary" @click="showDialogDelete(index)"><v-icon>mdi-delete</v-icon></v-btn>
              <div class="text-h4 ma-6" color="">Perfil {{ index }}</div>
            </v-toolbar>
            <v-card-text>
              <v-row class="ma-4">
                <v-col>
                  <v-text-field
                    v-model="quoteProfile.description"
                    label="Descrição"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-switch
                    v-model="quoteProfile.customKit"
                    label="Kit aberto"
                  ></v-switch>
                </v-col>

              <v-col>
                  <v-switch
                    v-model="quoteProfile.customMounting"
                    label="Montagem configurável"
                  ></v-switch>
                </v-col>
                
              </v-row>

              <edit-formula
                label="Fórmula de propostas"
                :formula="quoteProfile.formula"
                :fields="fields"
              ></edit-formula>

              <edit-formula-document
                label="Fórmula de geração de documento"
                :formula="quoteProfile.formulaDocument"
                :fields="fields"
              ></edit-formula-document>

              <edit-formula
                label="Fórmula de produtos"
                :formula="quoteProfile.formulaProducts"
                :fields="fields"
              ></edit-formula>

              <edit-formula
                label="Fórmula de serviços"
                :formula="quoteProfile.formulaServices"
                :fields="fields"
              ></edit-formula>

              <v-row class="ma-4">
                <v-spacer></v-spacer>
              </v-row>
            </v-card-text>
            <v-row class="ma-4"> </v-row>

            <!-- Default services -->
            <v-card class="ma-4">
              <v-toolbar class="grey lighten-1" dark>
                <div
                  class="text-subtitle-1"
                  :class="`blue-grey--text text--darken-2`"
                  color=""
                >
                  Serviços padrão
                </div>

                <v-spacer></v-spacer>

                <v-btn class="secondary" @click="openDialogService(index)"
                  >+Novo</v-btn
                >
              </v-toolbar>

              <v-container style="max-width: 90%" class="my-4">
                <div
                  v-for="(service, indexService) in quoteProfile.services"
                  v-bind:key="service.id"
                >
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-btn
                        class="secondary"
                        @click="deleteService(index, indexService)"
                      >
                        <v-icon>mdi-delete</v-icon></v-btn
                      >
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-text-field
                        label="Código"
                        hide-details="auto"
                        v-model="service.device.code"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="8">
                      <v-text-field
                        label="Descrição"
                        hide-details="auto"
                        v-model="service.device.description"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <edit-formula
                    :formula="service.formula"
                    :fields="fields"
                  ></edit-formula>
                </div>
                <!-- <v-row>
                  <v-spacer></v-spacer>
                  <v-btn class="primary" @click="dialog = true">
                    <v-icon>mdi-plus</v-icon></v-btn
                  >
                </v-row> -->
              </v-container>
            </v-card>

            <!-- Default products -->
            <v-card class="ma-4">
              <v-toolbar class="grey lighten-1" dark>
                <div
                  class="text-subtitle-1"
                  :class="`blue-grey--text text--darken-2`"
                  color=""
                >
                  Produtos padrão
                </div>

                <v-spacer></v-spacer>

                <v-btn class="secondary" @click="openDialogDevice(index)"
                  >+Novo</v-btn
                >
              </v-toolbar>

              <v-container style="max-width: 90%" class="my-4">
                <div
                  v-for="(product, indexProduct) in quoteProfile.products"
                  v-bind:key="product.id"
                >
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-btn
                        class="secondary"
                        @click="deleteDevice(index, indexProduct)"
                      >
                        <v-icon>mdi-delete</v-icon></v-btn
                      >
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-text-field
                        label="Código"
                        hide-details="auto"
                        v-model="product.device.code"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="8">
                      <v-text-field
                        label="Descrição"
                        hide-details="auto"
                        v-model="product.device.description"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <edit-formula
                    :formula="product.formula"
                    :fields="fields"
                  ></edit-formula>
                </div>
              </v-container>
            </v-card>

            <v-card>
              <v-toolbar class="grey lighten-1" dark>
                <div
                  class="text-subtitle-1"
                  :class="`blue-grey--text text--darken-2`"
                  color=""
                >
                  Configurações de orçamento
                </div>

                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text v-if="quoteProfile.devicesOptions">
                <v-row>
                <v-col>
                  <v-switch
                    v-model="quoteProfile.devicesOptions.stringbox"
                    label="Stringbox"
                  ></v-switch>
                </v-col>
                <v-col>
                  <v-switch
                    v-model="quoteProfile.devicesOptions.transformer"
                    label="Transformador"
                  ></v-switch>
                </v-col>

                <v-col>
                  <v-switch
                    v-model="quoteProfile.devicesOptions.structure"
                    label="Estrutura"
                  ></v-switch>
                </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card>
        </div>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import hebelApi from "../../../../libraries/hebel/hebelApi";
import EditFormula from "../../component/EditFormula.vue";
import EditFormulaDocument from "../../component/EditFormulaDocument.vue";
import ModalDevices from "../../components/modals/ModalDevices";
import ModalDelete from '../modals/ModalDelete.vue';
export default {
  name: "quote-profiles-card",
  props: ["quoteProfiles", "fields", "services"],
  components: {
    EditFormula,
    EditFormulaDocument,
    ModalDevices,
    ModalDelete,
  },
  data() {
    return {
      t: 1,
      dialog: false,
      dialogField: false,
      showDialogDevices: false,
      showDialogServices: false,
      selectedQuoteProfileIndex: 0,
      devices: [],
      dialogDelete:false,
      deleteIndex:-1,
      quote: {
        cost: 100,
        price: 100,
        fields: [
          // {"default":false,"object":"quote","id":"zwH8AtIaHusqdZjeMNDY","type":"","description":"Margem (%)",value:0}
        ],
      },
    };
  },

  async created() {
    this.devices = await hebelApi.devices.getAll("*", "*", true);
  },
  methods: {
     showDialogDelete(index){
        this.deleteIndex = index;
        this.dialogDelete =true;
    },
    deleteProfile() {
      if(this.deleteIndex !== -1){
        // var deal = this.deals[this.deleteIndex];
        // hebelApi.deals.delete(deal.id);
        this.quoteProfiles.splice(this.deleteIndex , 1);
      }
      this.dialogDelete = false;
    },
    addDevice(device, section) {
      var d = new Date();
      var s = Object.assign({}, device);
      var deviceAdd = {
        device: s,
        deviceId: s.id,
        id: d.getTime(),
        formula: { script: "", fields: [] },
      };

      if (section == "products") {
        if (!this.quoteProfiles[this.selectedQuoteProfileIndex].products)
          this.quoteProfiles[this.selectedQuoteProfileIndex].products = [];
        this.quoteProfiles[this.selectedQuoteProfileIndex].products.push(
          deviceAdd
        );
        this.showDialogDevices = false;
      }

      if (section == "services") {
        if (!this.quoteProfiles[this.selectedQuoteProfileIndex].services)
          this.quoteProfiles[this.selectedQuoteProfileIndex].services = [];
        this.quoteProfiles[this.selectedQuoteProfileIndex].services.push(
          deviceAdd
        );
        this.showDialogServices = false;
      }
    },
    addProfile() {
      var p = {
        description: "",
        customKit:false,
        customMounting:false,
        formula: {
          script: "",
          fields: [],
        },
        formulaDocument: {
          script: "",
          fields: [],
          images: [],
        },
        formulaServices: {
          script: "",
          fields: [],
        },
        formulaProducts: {
          script: "",
          fields: [],
        },
        services: [],
        products: [],
        devicesOptions: {
          stringbox: { enable: true, formula: "" },
          transformer: { enable: true, formula: "" },
          structure: { enable: true, formula: "" },
        },
      };
      this.quoteProfiles.push(p);
    },

    addService(index) {
      //alert(index);
      var d = new Date();
      var s = Object.assign({}, this.services[index]);
      var service = {
        device: s,
        deviceId: s.id,
        id: d.getTime(),
        formula: { script: "", fields: [] },
      };
      if (!this.quoteProfiles[this.selectedQuoteProfileIndex].services)
        this.quoteProfiles[this.selectedQuoteProfileIndex].services = [];
      this.quoteProfiles[this.selectedQuoteProfileIndex].services.push(service);
      this.dialog = false;
    },
    openDialogService(index) {
      this.selectedQuoteProfileIndex = index;
      this.showDialogServices = true;
    },
    openDialogDevice(index) {
      this.selectedQuoteProfileIndex = index;
      this.showDialogDevices = true;
    },

    openDialogField(index) {
      this.selectedQuoteProfileIndex = index;
      this.dialogField = true;
    },
    deleteField(indexQuoteProfile, indexField) {
      var field = this.quoteProfiles[indexQuoteProfile].formula.fields[
        indexField
      ];
      this.quoteProfiles[indexQuoteProfile].formula.script = this.quoteProfiles[
        indexQuoteProfile
      ].formula.script.replaceAll(`[${field.description}]`, "");
      this.quoteProfiles[indexQuoteProfile].formula.fields.splice(
        indexField,
        1
      );
    },

    addField(index) {
      this.quoteProfiles[
        this.selectedQuoteProfileIndex
      ].formula.script += `[${this.fields[index].description}]`;
      var f = Object.assign({}, this.fields[index]);
      this.quoteProfiles[this.selectedQuoteProfileIndex].formula.fields.push(f);
      this.dialogField = false;
    },
    deleteService(indexProfile, indexService) {
      // alert(indexService);
      this.quoteProfiles[indexProfile].services.splice(indexService, 1);
      this.$forceUpdate();
    },
    deleteDevice(indexProfile, index) {
      // alert(indexService);
      this.quoteProfiles[indexProfile].products.splice(index, 1);
      this.$forceUpdate();
    },
    testFormula(index) {
      //alert("test ")
      var formula = this.quoteProfiles[index].formula;
      var fields = formula.fields;
      var script = formula.script;
      this.quote.fields = [];
      var site = {
        cityName : "Campinas - SP",
        city : {name:"Campinas - SP", stateName :"SP"}

      };
      var f = 0;
      //When the user creates a quote
      for (f = 0; f < fields.length; f++) {
        var field = fields[f];
        if (!field.default) {
          this.quote.fields.push(field);
        }
      }
      var quote = this.quote;

      for (f = 0; f < fields.length; f++) {
        var field = fields[f];
        if (field.default) {
          script = script.replaceAll(`[${field.description}]`, field.id);
        } else {
          var selField = this.quote.fields.find(
            (element) => element.id == field.id
          );
          this.quote.fields.push(field);
          script = script.replaceAll(
            `[${selField.description}]`,
            selField.value
          );
        }
      }
      script = script.replaceAll("quote.", "this.quote.");
      try {
        //console.log(script)
        eval(script);

        alert(
          `OK-  Custo: ${quote.price},   Preço: ${
            quote.price
          }, Campos: ${JSON.stringify(this.quote.fields)} `
        );
      } catch (e) {
        alert(e);
        if (e instanceof SyntaxError) {
          alert(e);
        }
      }
    },
  },
};
</script>

<style scoped>
</style>